module.exports = __webpack_public_path__ + "static/media/sf-test-4.26494d59.mp3";